import { Actions } from './logistiqueActions';

/**
 * Etat initiale pour les informations logistiques d'une pièce.
 */
const initialState = {
    logistique: {
        infosLogistique: {},
        isInfosLogistiqueLoading: false
    }
};

/**
 * Reducer pour les informations logistiques sur une pièce.
 */
const reducer = (state = initialState, action) => {
    switch (action.type) {
        // Informations des infos logistique sur une pièce
        case Actions.FETCH_INFOS_LOGISTIQUE_REQUEST:
            return {
                ...state,
                logistique: {
                    ...state.logistique,
                    isInfosLogistiqueLoading: true
                }
            };
        case Actions.FETCH_INFOS_LOGISTIQUE_SUCCESS:
            return {
                ...state,
                logistique: {
                    ...state.logistique,
                    infosLogistique: action.infosLogistique,
                    isInfosLogistiqueLoading: false
                }
            };
        case Actions.FETCH_INFOS_LOGISTIQUE_FAILURE:
            return {
                ...state,
                logistique: {
                    ...state.logistique,
                    isInfosLogistiqueLoading: false,
                    error: action.error
                }
            };
        default:
            return state;
    }
};

export default reducer;